// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"E_TheComp__vDQ5k"};